import { FileText, Play, Trash2, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const fmtSize = (b) => (b > 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1).replace(".", ",")} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

export const FileQueue = ({ files, onRemove, onClear, onStart, startLabel, busy }) => (
  <section data-testid="file-queue" className="mt-6 rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 fade-up">
    <div className="flex items-center justify-between gap-3">
      <h2 className="font-display text-lg font-bold text-slate-900">
        <span data-testid="file-queue-count">{files.length}</span> {files.length === 1 ? "file pronto" : "file pronti"} da convertire
      </h2>
      <Button variant="ghost" size="sm" data-testid="file-queue-clear" onClick={onClear} className="text-slate-500">
        <Trash2 className="mr-1.5 h-4 w-4" /> Svuota
      </Button>
    </div>
    <ul className="mt-4 divide-y divide-slate-100 rounded-xl border border-slate-100">
      {files.map((f, i) => (
        <li key={`${f.name}-${f.size}-${i}`} data-testid={`file-queue-item-${i}`} className="flex items-center gap-3 px-4 py-2.5">
          <FileText className="h-4 w-4 shrink-0 text-emerald-700" />
          <span className="min-w-0 flex-1 truncate text-sm text-slate-800">{f.name}</span>
          <span className="shrink-0 font-mono text-xs text-slate-400">{fmtSize(f.size)}</span>
          <button type="button" data-testid={`file-queue-remove-${i}`} onClick={() => onRemove(i)} title="Togli dalla lista"
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-slate-400 hover:bg-red-50 hover:text-red-600">
            <X className="h-4 w-4" />
          </button>
        </li>
      ))}
    </ul>
    <p className="mt-3 text-xs text-slate-500">Puoi aggiungere altri PDF trascinandoli o cliccando sul riquadro sopra (fino a 30).</p>
    <Button data-testid="start-conversion-button" onClick={onStart} disabled={busy}
      className="mt-5 h-12 w-full sm:w-auto rounded-full bg-emerald-700 px-8 text-white hover:bg-emerald-800 btn-lift">
      <Play className="mr-2 h-4 w-4" /> {startLabel || `Converti ${files.length} ${files.length === 1 ? "file" : "file insieme"}`}
    </Button>
  </section>
);
